import React, { Component } from 'react';
import './App.css';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
const logo=require ('./logo.PNG');
class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
      <div className="App" >
        <header className="App-header">
          <h1 className="App-title">Permissions</h1>
          <img style={{height:'75%',}} src={logo} />
        </header>
            <Table showCheckboxes={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn>What we are using</TableHeaderColumn>
                  <TableHeaderColumn>Why we are using</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false} showRowHover>
                <TableRow>
                  <TableRowColumn>Manifest.permission.WRITE_EXTERNAL_STORAGE,</TableRowColumn>
                  <TableRowColumn>For taking Pictures And uploard them on server</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Manifest.permission.READ_EXTERNAL_STORAGE</TableRowColumn>
                  <TableRowColumn>For taking Pictures And Uploard them on Server</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Manifest.permission.CAMERA</TableRowColumn>
                  <TableRowColumn>For taking Pictures And Uploard them on Server</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Manifest.permission.ACCESS_COARSE_LOCATION</TableRowColumn>
                  <TableRowColumn>To get User Location and Show on Map</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>Manifest.permission.ACCESS_FINE_LOCATION</TableRowColumn>
                  <TableRowColumn>To get User Location and Show on Map</TableRowColumn>
                </TableRow>
                <TableRow>
                  <TableRowColumn>android.permission.GET_ACCOUNTS</TableRowColumn>
                  <TableRowColumn>To get Gmail account accesing</TableRowColumn>
                </TableRow>
              </TableBody>
            </Table>
      </div>
     </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js